import React from 'react';
import { Box, Link, TextField as MuiTextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

type Props = TextFieldProps & {
  validateIsNotEmpty?: boolean | undefined;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function LinkField(props: Props) {
  const { validateIsNotEmpty = false, handleChange, handleBlur, ...rest } = props;
  const [link, setLink] = React.useState<string>(`${props.value}`);

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
      <MuiTextField
        variant='standard'
        fullWidth
        required={validateIsNotEmpty || false}
        onChange={(event) => {
          const value = event.target.value;
          setLink(value);
          handleChange(value);
        }}
        inputProps={{
          onBlur: (event) => {
            if (handleBlur !== null && handleBlur !== undefined) {
              handleBlur(event.target.value);
            }
          },
        }}
        {...rest}
      />
      <Link href={link.length > 0 ? link : undefined} sx={{ p: '10px' }} target='_blank'>
        <OpenInNewIcon color={link.length > 0 ? 'primary' : 'disabled'} />
      </Link>
    </Box>
  );
}

export type { Props as LinkFieldProps };

export default LinkField;
